exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.email-button{display:flex;align-items:center;justify-content:center;height:100%;width:100%;opacity:.6;overflow:hidden}.email-button:hover{opacity:.8}.email-button.enabled{opacity:1;cursor:pointer}.email-button--send{flex:1;text-decoration:none;height:100%;border-radius:0 6px 0 0;background-color:#fff;display:flex;align-items:center;justify-content:space-between;flex-direction:column;padding:0 4px;margin-top:6px}.email-button--icon{height:25px;width:25px;top:9px;position:relative}.email-button--text{font-size:11px;color:#8b8b8b}.email-button--active-text{font-size:11px;color:#184e78}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/containers/PORContainer/EmailButton/EmailButton.scss
// module id = 1754
// module chunks = 0